import { Outlet } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { ThemeProvider as MDSThemeProvider } from '@emotion/react';
import { MuiThemeProvider } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import { theme } from '@marqvision/shared/src/library';
import { MDSResetCSS, MDSThemeValue } from '@marqvision/mds-v2';
import { useInterceptLink } from '@marqvision/shared';
import { ErrorBoundaryView } from '~/pages/ErrorPage/ErrorBoundary';
import { useAuth } from '~/apis';
import { useSentryUserInfoUpdate } from './hooks';
import './App.css';

const App = () => {
  const { data: authData } = useAuth();

  useSentryUserInfoUpdate();
  useInterceptLink(authData?.isClientView);

  return (
    <Sentry.ErrorBoundary fallback={<ErrorBoundaryView />} showDialog>
      <MuiThemeProvider theme={{ ...theme, ...MDSThemeValue }}>
        <MDSThemeProvider theme={MDSThemeValue}>
          <CssBaseline />
          <MDSResetCSS />
          <Outlet />
        </MDSThemeProvider>
      </MuiThemeProvider>
    </Sentry.ErrorBoundary>
  );
};

export default App;
